import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Popover, Progress, Tooltip, message } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import API from '@api/api.js';
import { AppContext, channel } from '@utils/AppContext';
import styles from './loggedHead.module.scss'
import CountUp from 'react-countup';
import eventBus from '@utils/eventBus';
import PayModal from '@view/compoents/payModal/payModal'
import CouponModal from '@view/compoents/couponModal/couponModal'
import SwitchHomePageType from '../SwitchHomePageType';
import Utils from '@utils/utils'
import * as PromoteButtons from '../PromoteButtons';

function LoggedAvatar (props) {
    const {goPerson, goCoupon, goBack} = props
    const { globalUser } = useContext(AppContext);
    const [open, setOpen] = useState(false)
    
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if (newOpen) {
            eventBus.emit('updateUserInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }
    }

    const memberLevel = useMemo(() => {
        return globalUser?.membership?.level
    }, [globalUser])

    const memberName = useMemo(() => {
        return globalUser?.membership?.plan.slice(-4)
    }, [globalUser])

    const balancePercent = useMemo(() => {
        return Math.ceil(globalUser?.membership?.balance / globalUser?.membership?.amount * 100)
    }, [globalUser])

    const content = (
        <div className={styles.LoggedAvatarPopover_box}>
            {
                !!globalUser &&
                <div>
                    <div className={styles.popover_box_}>
                        <div className={styles.popover_box_top}>
                            <img className={styles.img1} src={require('@assets/images/icon_Avatar_2.png')} alt="" />
                            <ul>
                                <li className={styles.li1}>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</li>
                                <li className={styles.li2}>
                                    <i className={`${styles.vip_icon} ${styles["level_"+memberLevel]}`}></i>
                                    <span>{!memberLevel ? "您还未开通会员" : memberName}</span>
                                </li>
                            </ul>
                        </div>
                        <p className={styles.balance_p}>
                            <i className={styles.arcbean}></i>
                            <span>剩余虹豆</span>
                            <p>
                                <span>{globalUser?.membership?.balance}</span>
                                <span>/</span>
                                <span>{globalUser?.membership?.amount}</span>
                            </p>
                        </p>
                        <Progress
                            className={styles.balance_progress}
                            showInfo={false}
                            percent={balancePercent}
                        />
                        {
                            localStorage.getItem('channel') == 'taobao' ? null : <>
                                <p className={styles.coupon_p} onClick={() => {goCoupon();setOpen(false);}}>我的优惠券</p>
                                <p className={styles.center_p} onClick={() => {goPerson();setOpen(false);}}>个人中心</p>
                            </>
                        }
                        <p className={styles.logout_p} onClick={() => {goBack();setOpen(false);}}>退出登录</p>
                    </div>
                </div>
            }
        </div>
    );

    return (
        <Popover
            overlayClassName={styles.LoggedAvatarPopover}
            placement="bottomRight"
            content={content}
            trigger="click"
            onOpenChange={handleOpenChange}
            open={open}
        >
            <div className={styles.LoggedAvatar}>
                <img className={styles.LoggedAvatarImage} onClick={() => setOpen(true)} src={require('@assets/images/icon_Avatar_2.png')} alt="" />
                <i className={`${styles.vip_icon} ${styles["level_"+memberLevel]}`}></i>
            </div>
        </Popover>
    )
}

function LoggedHead(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const payChildRef = useRef(null);
    const couponChildRef = useRef()
    const { globalBalance, setHasToken, setGlobaluser } = useContext(AppContext);
    const [powerBalance, setPowerBalance] = useState(globalBalance)

    useEffect(() => {
        setPowerBalance(globalBalance)
    }, [globalBalance])

    // 用来检查是否有虹豆/套餐到期需要提醒
    useEffect(() => {
        eventBus.emit('updateOrderList')
    }, [])

    // 多账号登录时更新账号信息
    useEffect(() => {
        eventBus.emit('updateUserInfo')
        eventBus.emit('updatePower')
        eventBus.emit('updateActivityInfo')
    }, [location])

    const goPerson = () => {
        window.open("/home/homemain/personalCenter", "_blank");
        // navigate("/home/homemain/personalCenter")
    }

    const goBack = () => {
        API.logout({}).then(res => {
            navigate('/')
            setGlobaluser()
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
            setHasToken(false)
        }).catch((error) => {
            navigate('/')
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
            setHasToken(false)
        })
    }

    const openCouponClick = () => {
        couponChildRef.current.openClick()
    }

    const [startBalance, setStartBalance] = useState(0)
    const [endBalance, setEndBalance] = useState(0)
    const endBalanceRef = useRef(0)
    const balanceRef = useRef()

    useEffect(() => {
        endBalanceRef.current = powerBalance
        setEndBalance(powerBalance)
    }, [powerBalance])
    const charsLength = useMemo(() => {
        function formatNumber(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return formatNumber(endBalance).length
    }, [endBalance])
    // const adjustBalanceWidth = useMemo(() => {
    //     function formatNumber(num) {
    //         return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     }
    //     if (!balanceRef.current) return 0
    //     // 创建一个临时span
    //     const tempSpan = document.createElement('span');
    //     // 设置相同的文本
    //     tempSpan.textContent = formatNumber(endBalance);
    //     // 设置相同的字体和样式，确保测量准确
    //     const style = window.getComputedStyle(balanceRef.current);
    //     tempSpan.style.font = style.font;
    //     tempSpan.style.fontSize = style.fontSize;
    //     tempSpan.style.fontFamily = style.fontFamily;
    //     tempSpan.style.fontWeight = style.fontWeight;
    //     tempSpan.style.fontStyle = style.fontStyle;
    //     tempSpan.style.letterSpacing = style.letterSpacing;
    //     // 将span添加到body，但不可见
    //     tempSpan.style.position = 'absolute';
    //     tempSpan.style.visibility = 'hidden';
    //     tempSpan.style.whiteSpace = 'nowrap'; // 防止换行
    //     document.body.appendChild(tempSpan);
    //     // 获取宽度
    //     const width = tempSpan.offsetWidth;
    //     return width
    // }, [endBalance, balanceRef.current])
    const countUpEnd = () => {
        setStartBalance(endBalanceRef.current)
    }

    const openPayClick = () => {
        if (localStorage.getItem('channel') == 'taobao') return
        payChildRef.current.openrechargeClick()
    }
    return (
        <div className={styles.LoggedHead}>
            <PromoteButtons.InviteBtn />
            {localStorage.getItem('channel') != 'taobao' && <PromoteButtons.MembershipBtn onClick={openPayClick} />}
            <div onClick={openPayClick} className={styles.LoggedHead_power}>
                <span className={styles.LoggedHead_powerAmount} ref={balanceRef} style={{width: `calc(${charsLength} * 1ch)`}}>
                {<CountUp start={startBalance} end={endBalance} separator="," onEnd={countUpEnd} />}
                </span>
            </div>
            <LoggedAvatar
                goCoupon={openCouponClick}
                goPerson={goPerson}
                goBack={goBack}
            />
            <PayModal ref={payChildRef}></PayModal>
            <CouponModal ref={couponChildRef} />
        </div>
    )
}

export default LoggedHead